/* Zambezi Roots — Help Assistant (Shopify theme build)
   Self-contained, no backend. Links route to the store's real pages. */
(function () {
  'use strict';

  if (window.__zrChatInit) return;
  window.__zrChatInit = true;

  var urls = window.ZR_URLS || {};
  var shippingUrl = urls.shipping || '/pages/shipping-pickup-and-returns-policy';
  var returnsUrl = urls.returns || (shippingUrl + '#returns');
  var contactUrl = urls.contact || '/pages/contact-us';

  var TOPICS = [
    {
      id: 'faq',
      label: "FAQ’s 🤔",
      keywords: ['faq', 'help', 'question', 'info'],
      answer: 'Happy to help! Here are the things we get asked most — tap one, or just type your question:',
      followups: ['sizing', 'shipping', 'returns', 'industries', 'restock', 'team', 'track']
    },
    {
      id: 'returns',
      label: 'How do I arrange a return / exchange? 📦',
      keywords: ['return', 'exchange', 'refund', 'swap', 'wrong size', 'send back'],
      answer: 'Please review our <a href="' + returnsUrl + '" target="_top">Returns Information</a> before sending anything back. Contact us with your order number and the reason for the request, then wait for return instructions.<br><br>For order status, reach out via the <a href="' + contactUrl + '#contactForm" target="_top">Contact page</a> with your order number.'
    },
    {
      id: 'sizing',
      label: 'How do I pick the right size? 🧵',
      keywords: ['size', 'sizing', 'fit', 'measure', 'too small', 'too big', 'chart', 'xs', 'xl', '2xl'],
      answer: 'Our scrubs run <strong>true to size</strong> (XS–2XL) with a relaxed, comfortable fit — and you can order your <strong>top and bottom in different sizes</strong>.<br><br>Try the quick <a href="/pages/size-guide#size-chart" target="_top">Size Finder &amp; chart</a> — pop in your bust/waist/hip and it recommends each piece. Between sizes? We’d size up for comfort.'
    },
    {
      id: 'shipping',
      label: 'Shipping cost & delivery times 🚚',
      keywords: ['shipping', 'delivery', 'postage', 'ship', 'how long', 'arrive', 'dispatch', 'cost'],
      answer: 'Orders are dispatched from <strong>Perth</strong>. Delivery options and charges are shown at checkout.<br><br>Tracking details are provided after dispatch. See the <a href="' + shippingUrl + '" target="_top">Shipping Policy</a> for full delivery information.'
    },
    {
      id: 'restock',
      label: 'When are you expecting a restock? 👖',
      keywords: ['restock', 'sold out', 'out of stock', 'back in stock', 'coming soon', 'new', 'waitlist', 'cap', 'jogger', 'scrunchie'],
      answer: 'Coming soon — leave your email and we’ll let you know when new ranges are ready.'
    },
    {
      id: 'industries',
      label: 'Do you make workwear for my industry? 🧰',
      keywords: ['industry', 'profession', 'apron', 'chef', 'hospitality', 'cafe', 'café', 'restaurant', 'barista', 'salon', 'spa', 'barber', 'hairdresser', 'beauty', 'corporate', 'office', 'polo', 'retail', 'teacher', 'not a nurse', 'non healthcare'],
      answer: 'Zambezi Roots is African-inspired <strong>professional workwear</strong> for many industries. Right now the store offers <strong>scrub sets, scrub separates and lanyards</strong> — with more ranges planned.<br><br>Browse current workwear <a href="/collections/all" target="_top">here</a>, or tell us your industry and we’ll point you to the best fit from what’s available today.'
    },
    {
      id: 'team',
      label: 'Guide to team orders 👯',
      keywords: ['team', 'group', 'clinic', 'bulk', 'wholesale', 'staff', 'uniform', 'embroidery'],
      answer: 'Kitting out a team — hospitality, retail, clinical, corporate or any workplace? Group orders can be planned across scrub sets, separates and lanyards.<br><br>See how it works and submit an enquiry on our <a href="/pages/group-orders" target="_top">Group Orders</a> page.'
    },
    {
      id: 'track',
      label: 'Track my order 📍',
      keywords: ['track', 'where is', 'order status', 'tracking', 'parcel'],
      answer: 'Tracking details are sent by email after dispatch. For the latest status, send your order number through the <a href="' + contactUrl + '#contactForm" target="_top">Contact page</a> — or leave your email here and we’ll chase it for you.'
    },
    {
      id: 'story',
      label: 'What does my scrub name mean? 🌍',
      keywords: ['name', 'mean', 'meaning', 'akanaka', 'sihle', 'maridadi', 'entle', 'ewa', 'language', 'culture', 'story'],
      answer: 'Every piece is named in an African language: <em>Akanaka</em> - "beautiful" (Shona), <em>Sihle</em> - "beautiful one" (Zulu), <em>Maridadi</em> - "stylish" (Swahili), <em>Entle</em> (Xhosa) and <em>Ewa</em> (Yoruba).<br><br>Read the why behind it on <a href="/pages/our-story" target="_top">Our Story</a>.'
    }
  ];

  var GREETING = "Hi, welcome to Zambezi Roots 👋 African-inspired workwear for every profession. Ask me about sizing, shipping, returns, your industry, or what’s coming soon.";
  var DEFAULT_CHIPS = ['faq', 'sizing', 'shipping', 'industries', 'restock', 'team'];

  function topicById(id) { for (var i = 0; i < TOPICS.length; i++) if (TOPICS[i].id === id) return TOPICS[i]; return null; }

  var launch = document.createElement('button');
  launch.className = 'zr-chat-launch';
  launch.setAttribute('aria-label', 'Open help chat');
  launch.hidden = true;
  launch.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 12a8 8 0 0 1-8 8H7l-4 3V12a8 8 0 0 1 8-8h2a8 8 0 0 1 8 8z"/></svg> Need help?';

  var panel = document.createElement('div');
  panel.className = 'zr-chat';
  panel.setAttribute('role', 'dialog');
  panel.setAttribute('aria-label', 'Zambezi Roots help chat');
  panel.innerHTML =
    '<div class="zr-chat-head">' +
      '<div class="row">' +
        '<div class="avatar">ZR</div>' +
        '<div class="title">Zambezi Roots Help<small>Connected by culture • typically replies instantly</small></div>' +
        '<div class="actions">' +
          '<button type="button" data-zr-cart aria-label="View bag"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 7h12l-1 13H7L6 7Z"/><path d="M9 7a3 3 0 0 1 6 0"/></svg></button>' +
          '<button type="button" data-zr-close aria-label="Close chat"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 6l12 12M18 6 6 18"/></svg></button>' +
        '</div>' +
      '</div>' +
      '<div class="note">Automated helper for quick answers. For anything else, leave your email and a human will follow up.</div>' +
    '</div>' +
    '<div class="zr-chat-body" id="zrChatBody"></div>' +
    '<form class="zr-chat-input" id="zrChatForm">' +
      '<input type="text" id="zrChatInput" placeholder="Ask anything…" autocomplete="off" aria-label="Type your question">' +
      '<button type="submit" aria-label="Send"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 2 11 13M22 2l-7 20-4-9-9-4 20-7z"/></svg></button>' +
    '</form>';

  document.body.appendChild(launch);
  document.body.appendChild(panel);

  var body = panel.querySelector('#zrChatBody');
  var form = panel.querySelector('#zrChatForm');
  var input = panel.querySelector('#zrChatInput');
  var started = false;
  var awaitingEmail = false;
  var suppressed = false;
  var wasOpenBeforeSuppress = false;

  function scrollDown() { body.scrollTop = body.scrollHeight; }
  function addMsg(html, who) {
    var m = document.createElement('div');
    m.className = 'zr-msg ' + (who || 'bot');
    m.innerHTML = html;
    body.appendChild(m);
    scrollDown();
    return m;
  }
  function addChips(ids) {
    var wrap = document.createElement('div');
    wrap.className = 'zr-chips';
    ids.forEach(function (id) {
      var t = topicById(id);
      if (!t) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'zr-chip';
      b.textContent = t.label;
      b.addEventListener('click', function () { chooseTopic(t, b.textContent); });
      wrap.appendChild(b);
    });
    body.appendChild(wrap);
    scrollDown();
  }
  function clearChips() { body.querySelectorAll('.zr-chips').forEach(function (c) { c.remove(); }); }

  function chooseTopic(topic, label) {
    clearChips();
    addMsg(label || topic.label, 'user');
    setTimeout(function () {
      addMsg(topic.answer, 'bot');
      if (topic.followups && topic.followups.length) addChips(topic.followups);
      else addChips(['faq', 'restock', 'team']);
    }, 240);
  }

  function isEmail(s) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s); }

  function matchTopic(text) {
    var q = text.toLowerCase();
    var best = null, bestScore = 0;
    TOPICS.forEach(function (t) {
      var score = 0;
      t.keywords.forEach(function (k) { if (q.indexOf(k) !== -1) score++; });
      if (score > bestScore) { bestScore = score; best = t; }
    });
    return bestScore > 0 ? best : null;
  }

  function handleText(text) {
    addMsg(text.replace(/</g, '&lt;'), 'user');
    if (awaitingEmail) {
      awaitingEmail = false;
      if (isEmail(text.trim())) {
        setTimeout(function () {
          addMsg('Got it — we’ll be in touch at <strong>' + text.trim().replace(/</g, '&lt;') + '</strong> shortly. Anything else I can help with?', 'bot');
          addChips(['sizing', 'shipping', 'restock']);
        }, 240);
        if (window.zrToast) window.zrToast('Thanks!', 'A human will follow up by email');
      } else {
        setTimeout(function () { addMsg('That doesn’t look like an email — mind trying again? Or reach us any time on the <a href="' + contactUrl + '" target="_top">Contact</a> page.', 'bot'); }, 240);
        awaitingEmail = true;
      }
      return;
    }
    var topic = matchTopic(text);
    setTimeout(function () {
      if (topic) {
        addMsg(topic.answer, 'bot');
        addChips((topic.followups && topic.followups.length) ? topic.followups : ['faq', 'restock', 'team']);
      } else {
        awaitingEmail = true;
        addMsg('Good question — I want to get that right. Pop your <strong>email</strong> here and a human from the team will reply within 1 business day. Or pick a topic below:', 'bot');
        addChips(['faq', 'sizing', 'shipping', 'returns']);
      }
    }, 240);
  }

  function startChat() {
    if (started) return;
    started = true;
    addMsg(GREETING, 'bot');
    addChips(DEFAULT_CHIPS);
  }

  /* Change-guarded DOM writes: suppress()/restore() are called from the
     overlay coordinator's (debounced) MutationObserver path, so they must
     not touch observed attributes when nothing actually changes. */
  function setHidden(el, hidden) {
    if (el.hidden !== !!hidden) el.hidden = !!hidden;
  }
  function setBodyClass(name, on) {
    if (document.body.classList.contains(name) === !!on) return;
    document.body.classList.toggle(name, !!on);
  }

  function zrEmit(name, detail) {
    if (window.ZRAnalytics && typeof window.ZRAnalytics.emit === 'function') {
      return window.ZRAnalytics.emit(name, detail);
    }
    return false;
  }

  function open() {
    if (suppressed) return;
    if (window.zrOverlay && (window.zrOverlay.isConsentVisible() || window.zrOverlay.isPromoOpen())) return;
    panel.classList.add('open');
    setHidden(launch, true);
    setBodyClass('zr-overlay-chat', true);
    startChat();
    zrEmit('chat_open', { source: 'chat_launcher' });
    setTimeout(function () { input.focus(); }, 200);
  }

  function close() {
    var wasOpen = panel.classList.contains('open');
    panel.classList.remove('open');
    setBodyClass('zr-overlay-chat', false);
    if (!suppressed) setHidden(launch, false);
    if (wasOpen) zrEmit('chat_close', { source: 'chat_panel' });
  }

  function suppress() {
    if (suppressed) {
      setHidden(launch, true);
      return;
    }
    suppressed = true;
    wasOpenBeforeSuppress = panel.classList.contains('open');
    if (wasOpenBeforeSuppress) panel.classList.remove('open');
    setHidden(launch, true);
    setBodyClass('zr-overlay-chat', false);
    setBodyClass('zr-chat-suppressed', true);
  }

  function restore() {
    if (window.zrOverlay && (window.zrOverlay.isConsentVisible() || window.zrOverlay.isPromoOpen())) {
      suppress();
      return;
    }
    suppressed = false;
    setBodyClass('zr-chat-suppressed', false);
    if (wasOpenBeforeSuppress) {
      wasOpenBeforeSuppress = false;
      open();
    } else {
      setHidden(launch, false);
    }
  }

  launch.addEventListener('click', open);
  panel.querySelector('[data-zr-close]').addEventListener('click', close);
  panel.querySelector('[data-zr-cart]').addEventListener('click', function () { window.location.href = (window.routes && window.routes.cart_url) || '/cart'; });

  function chatFocusables() {
    return panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled])');
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (window.zrOverlay && window.zrOverlay.isConsentVisible()) return;
      if (panel.classList.contains('open')) {
        e.preventDefault();
        close();
        launch.focus();
      }
      return;
    }
    if (e.key !== 'Tab' || !panel.classList.contains('open')) return;
    var items = chatFocusables();
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    } else if (!panel.contains(document.activeElement)) {
      e.preventDefault();
      first.focus();
    }
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var text = input.value.trim();
    if (!text) return;
    input.value = '';
    handleText(text);
  });

  window.zrChat = {
    suppress: suppress,
    restore: restore,
    close: close,
    isOpen: function () { return panel.classList.contains('open'); }
  };

  if (
    document.body.classList.contains('zr-overlay-consent') ||
    document.body.classList.contains('zr-overlay-promo') ||
    document.body.classList.contains('zr-chat-suppressed') ||
    (window.zrOverlay && (window.zrOverlay.isConsentVisible() || window.zrOverlay.isPromoOpen()))
  ) {
    suppress();
  } else {
    launch.hidden = false;
  }
})();
